const data = [
	{
		icon: require('../../../assets/images/fb_btn.png'),
		name: 'Facebook',
		account_name: '',
		channel: 104,
		binded: 0,
	},
	{
		icon: require('../../../assets/images/fb_btn.png'),
		name: 'Facebook',
		account_name: '',
		channel: 109,
		binded: 1,
	},
	{
		icon: require('../../../assets/images/twitter_btn.png'),
		name: 'Twitter',
		account_name: '',
		channel: '',
		binded: 1,
	},
	{
		icon: require('../../../assets/images/google_btn.png'),
		name: 'Google',
		account_name: '',
		channel: 105,
		binded: 0,
	},
	{
		icon: require('../../../assets/images/apple_btn.png'),
		name: 'Apple',
		account_name: '',
		channel: 103,
		binded: 0,
	},
	{
		icon: require('../../../assets/images/line_btn.png'),
		name: 'Line',
		account_name: '',
		channel: 108,
		binded: 0,
	},
	{
		icon: require('../../../assets/images/ins_btn.png'),
		name: 'Insgrame',
		account_name: '',
		channel: '',
		binded: 0,
	},
	{
		icon: require('../../../assets/images/games_center_btn.png'),
		name: 'Game Center',
		account_name: '',
		channel: '110',
		binded: 0,
	},
	{
		icon: require('../../../assets/images/kakao.png'),
		name: 'KaKao',
		account_name: '',
		channel: '112',
		binded: 0,
	},
	{
		icon: require('../../../assets/images/n_btn.png'),
		name: 'Naver',
		account_name: '',
		channel: '113',
		binded: 0,
	},
	{
		icon: require('../../../assets/images/gpg.png'),
		name: 'Google Play Games',
		account_name: '',
		channel: '',
		binded: 0,
	},
];
export default data;
